import {createLazyLoadTrigger} from "@/laraberg_frontend/general"

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSliders)
} else {
    // Todo: Hotfix for slider init on /de/tester-showroom. Problem can be related with #app vue initialization and html re-rendering
    setTimeout(() => {
        initSliders()
    }, 1000)
}

function initSliders() {
    const sliders = document.querySelectorAll(".slider")
    if (!sliders.length) return
    createLazyLoadTrigger(".slider", 200, async () => {
        const [{default: Swiper}, {Autoplay, Pagination, Navigation}] = await Promise.all([
            import("swiper"),
            import("swiper/modules")
        ])

        sliders.forEach((slider) => {
            const noSliderForMobile = slider.classList.contains("slider-not-mobile")
            const noGap = slider.classList.contains("no-gap")

            const breakpoints = {
                1: {slidesPerView: 1},
                819: {slidesPerView: 2},
                1020: {slidesPerView: 3},
                1290: {slidesPerView: slider.classList.contains("slider-size-6") ? 6 : 4}
            }

            let swiperInstance = null

            const initializeSwiper = () => {
                const totalSlides = slider.querySelectorAll(".swiper-slide").length

                if (window.innerWidth > 819 || !noSliderForMobile) {
                    if (!swiperInstance && totalSlides > 0) {
                        const sliderOuter = slider.closest(".slider-outer")
                        const navigationPrevEl = sliderOuter?.querySelector(".swiper-button-prev")
                        const navigationNextEl = sliderOuter?.querySelector(".swiper-button-next")
                        const paginationEl = sliderOuter?.querySelector(".swiper-pagination")

                        swiperInstance = new Swiper(slider, {
                            modules: [Autoplay, Pagination, Navigation],
                            slidesPerView: slider.classList.contains("slider-size-6") ? 6 : 4,
                            spaceBetween: noGap ? 0 : 20,
                            breakpoints: breakpoints,
                            navigation: {
                                nextEl: navigationNextEl,
                                prevEl: navigationPrevEl
                            },
                            pagination: {
                                el: paginationEl,
                                clickable: true
                            },
                            on: {
                                init() {
                                    toggleNavigationVisibility(swiperInstance, totalSlides)
                                },
                                resize() {
                                    toggleNavigationVisibility(swiperInstance, totalSlides)
                                }
                            }
                        })

                        slider.swiper = swiperInstance
                    }
                } else {
                    if (swiperInstance) {
                        swiperInstance.destroy()
                        swiperInstance = null
                    }

                    slider.classList.add("manual-swipe-mode")

                    const sliderOuter = slider.closest(".slider-outer")
                    sliderOuter?.querySelectorAll(".swiper-button-prev, .swiper-button-next, .swiper-pagination")?.forEach(el => el.style.display = "none")

                    slider.style.overflowX = "auto"
                    slider.style.scrollBehavior = "smooth"
                    slider.style.cursor = "grab"

                    let isDragging = false
                    let startX = 0

                    slider.addEventListener("mousedown", (e) => {
                        isDragging = true
                        startX = e.pageX - slider.offsetLeft
                        slider.style.cursor = "grabbing"
                    })

                    slider.addEventListener("mousemove", (e) => {
                        if (!isDragging) return
                        e.preventDefault()
                        const x = e.pageX - slider.offsetLeft
                        const walk = x - startX
                        slider.scrollLeft -= walk
                    })

                    slider.addEventListener("mouseup", () => {
                        isDragging = false
                        slider.style.cursor = "grab"
                    })

                    slider.addEventListener("mouseleave", () => {
                        isDragging = false
                        slider.style.cursor = "grab"
                    })
                }
            }

            // Function to toggle navigation visibility based on number of slides and slidesPerView
            const toggleNavigationVisibility = (swiper, totalSlides) => {
                if (!swiper || !swiper.params) return
                let slidesPerView = swiper.params.slidesPerView
                // Handle case where slidesPerView is an object with breakpoints
                if (typeof slidesPerView === "object") {
                    // Find the current slidesPerView based on the window width (using the swiper breakpoints)
                    const currentBreakpoint = Object.keys(swiper.params.breakpoints).reverse().find(bp => window.innerWidth >= bp)
                    slidesPerView = swiper.params.breakpoints[currentBreakpoint]?.slidesPerView || slidesPerView
                }

                const {navigation} = swiper
                const sliderControll = swiper.el.closest(".slider-outer")?.querySelector(".slider-controls")

                // Hide controls if the total slides are less than or equal to slidesPerView
                if (totalSlides <= slidesPerView) {
                    navigation.prevEl?.classList.add("d-none")
                    navigation.nextEl?.classList.add("d-none")
                    sliderControll?.classList.add("d-none") // Hide the entire control container
                } else {
                    navigation.prevEl?.classList.remove("d-none")
                    navigation.nextEl?.classList.remove("d-none")
                    sliderControll?.classList.remove("d-none") // Show the control container
                }
            }

            initializeSwiper()
            window.addEventListener("resize", initializeSwiper, {passive: true})
        })
    })
}
